module.exports = __webpack_public_path__ + "img/banner-img-03.61f35056.svg";